import React from 'react';
import '../App.css';
import { Headerapp } from './/headerapp'
import { Bodyapprecopassbody} from './/bodyapprecopassbody'
import { Footerapp } from './/footerapp'

export class Bodyapparecopass extends React.Component {
  constructor(props){
    super (props);

    this.state={
        mail:''
    };
  }

  render(){
    return (
      <div className="App">        
        <Headerapp/>
        <Bodyapprecopassbody/>
        <Footerapp/>
      </div>
    );
  }
}